import api from 'api';
import { Dispatch, SetStateAction, useCallback, useEffect, useRef } from 'react';
import { NotificationType } from 'types';
import { useClickOutside } from 'hooks/click-outside';
import './notifications.scss';
import moment from 'moment';

function Notifications({
    open,
    notifications,
    buttonRef,
    setOpen,
    setNotifications
} : {
    open: boolean,
    notifications: NotificationType[],
    buttonRef: any,
    setOpen: Dispatch<SetStateAction<boolean>>,
    setNotifications: Dispatch<SetStateAction<NotificationType[]>>
}) {
    const ref = useRef<any>();
    useClickOutside([buttonRef, ref], () => {
        setOpen(false);
    });

    const getNotifications = useCallback(async () => {
        const data = await api.notifications.getAll();
        setNotifications(data);
    }, [setNotifications])

    const getTutorial = async (id: number) => {
        const data = await api.mentor.get(id);
        return data;
    }

    const setNotificationAsSeen = async (id: number) => {
        await api.notifications.seen([id]);
        let copiedData = [...notifications];
        let notification = copiedData.find(x => x.Id === id);
        notification!.DateSeen = moment();
        setNotifications(copiedData);
    }

    const handleNotificationClick = async (id: number, notificationTypeId: number) => {
        switch (notificationTypeId) {
            case 1: 
                return;
            case 2:
                setNotificationAsSeen(id); 
                return;
            case 4: 
                const tutorial = await getTutorial(id);
                console.log(tutorial);
                return;
        }
    }

    useEffect(() => {
        getNotifications();
    }, [getNotifications])

    return (
        <div className={`notifications ${open ? 'open' : ''}`} ref={ref}>
            <p className="title">Notifications</p>
            <i className="fal fa-times" onClick={() => setOpen(false)}></i>
            {notifications.length === 0 && <i className="none">No new notifications</i>}
            {notifications.map((x, i) => (
                <div className={`notification ${i === 0 ? 'unread' : ''}`} key={i} onClick={() => handleNotificationClick(x.Id, x.NotificationTypeId)}>
                    <div className="left">
                        <img src={`${process.env.PUBLIC_URL}/img/Logo.png`} alt="" />
                    </div>
                    <div className="right">
                        <p className="notification-description">{x.Description}</p>
                        <p className="notification-date">{moment(x.DateCreated).fromNow()}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Notifications;